import React from 'react'
import { Route } from 'react-router-dom'
import SignIn from './SignIn'

const SingleSignOn = () => {
  return <Route path='/sso' component={SignIn} />
}

export default SingleSignOn
